import { render, staticRenderFns } from "./TrainingEventList.vue?vue&type=template&id=f7889f98"
import script from "./TrainingEventList.vue?vue&type=script&lang=js"
export * from "./TrainingEventList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports